import React, { useState } from "react";
import Header from "@/components/atomics/guideheader";
import GuidePopup from "@/components/atomics/guidePopup";
import StepButton from "@/components/atomics/step-button";
import StepLoad from "@/components/atomics/step-load";

interface NextGuideProps {
  title: string;
  data: {
    popupTitle: string;
    subTitle: string;
    subContent: string[];
  }[];
  className?: string;
  onFinish: () => void;
  onCancelClick: () => void;
}

const NextGuide = ({
  title,
  data,
  className,
  onFinish,
  onCancelClick,
}: NextGuideProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div>
      <Header title={title} onCancelClick={onCancelClick} />
      <div className="min-h-[515px] px-[24px] pt-[28px] pb-[20px] sl:pb-[50px]">
        <div className="font-spline-sans-mono text-[21px]">
          <h3
            className="font-bold pb-[10px]"
            dangerouslySetInnerHTML={{ __html: data[currentIndex].subTitle }}
          />
          {data[currentIndex].subContent.map((item, index) => (
            <div className="flex text-lg sl:text-xl">
              <p className="mt-[-4px]">.</p>
              <p dangerouslySetInnerHTML={{ __html: item }} />
            </div>
          ))}
        </div>
        <GuidePopup
          title={data[currentIndex].popupTitle}
          className="mt-[30px]"
          isReverse={currentIndex === data.length - 1 ? true : false}
        />
        <StepLoad currentIndex={currentIndex} totalIndex={data.length} />
        <StepButton
          className="text-primary-blue"
          currentIndex={currentIndex}
          totalIndex={data.length}
          onPreviousStep={() => setCurrentIndex(currentIndex - 1)}
          onNextStep={() => setCurrentIndex(currentIndex + 1)}
          onFinish={onFinish}
        />
      </div>
    </div>
  );
};

export default NextGuide;
